import { createContext, createSignal } from "solid-js";
import type { IFileType } from "~/solidJs/shared/helpers/fileHelpers";
import { type DoubleLinkedListNode, LinkedList } from "~/solidJs/shared/helpers/linkedList";
export type ListNodeType = {
	asset: IFileType;
	nodeUuid: string;
};
export const [getIsFullScreenModalShown, setIsFullScreenModalShown] = createSignal(false);
export const [getFullScreenValues, setFullScreenValues] = createSignal<{
	activeItem?: DoubleLinkedListNode<ListNodeType>;
}>({});
export const FullScreenViewerContext = createContext<{
	getFullScreenValues: typeof getFullScreenValues;
	setFullScreenValues: typeof setFullScreenValues;
}>();
export const fullscreenLinkedList = new LinkedList<ListNodeType>();
